module.exports = __webpack_public_path__ + "media/boost-170b260e3893e627c78b5c7fd2b7c2d0.mp3";